module.exports = __webpack_public_path__ + "img/FR14633.e9e700fc.svg";